import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'viega-start-page',
    templateUrl: './viega-start-page.component.html',
    styleUrls: ['./viega-start-page.component.scss'],
})
export class ViegaStartPageComponent {
    @Input()
    public headlineText: string;

    @Input()
    public subHeadlineText: string;

    @Input()
    public backgroundUrl: string;

    @Input()
    public backgroundCssClass: string = '';
}



// WEBPACK FOOTER //
// ./src/viega-common/components/viega-start-page/viega-start-page.component.ts